/**
 * Collections grid title auto-fit
 *
 * Purpose: category tile titles (e.g. "Ultraschalltherapie") must not break
 * mid-word. Instead of hyphenating, shrink the title font-size per grid so the
 * longest SINGLE WORD fits the tile width on one line. Multi-word titles (e.g.
 * "Wundversorgung | Verbandstoffe") may still wrap at spaces. All titles within
 * one grid share the same computed size, so the row stays visually level.
 *
 * Self-calibrating: measures real rendered widths at runtime, no hardcoded px.
 * Graceful degradation: without JS the CSS keeps `hyphens: auto` as fallback.
 */
(function () {
  var MIN_PX = 14; // lower bound — never shrink smaller than this

  function makeMeasurer(cs) {
    var m = document.createElement('span');
    m.setAttribute('aria-hidden', 'true');
    m.style.cssText =
      'position:absolute;left:-9999px;top:-9999px;white-space:nowrap;visibility:hidden;pointer-events:none;';
    m.style.fontFamily = cs.fontFamily;
    m.style.fontWeight = cs.fontWeight;
    m.style.fontStyle = cs.fontStyle;
    m.style.fontSize = cs.fontSize;
    m.style.letterSpacing = cs.letterSpacing;
    m.style.textTransform = cs.textTransform; // uppercase widens text — must match
    document.body.appendChild(m);
    return m;
  }

  function widestWordPx(measurer, text) {
    var words = text.trim().split(/\s+/);
    var max = 0;
    for (var i = 0; i < words.length; i++) {
      measurer.textContent = words[i];
      var w = measurer.getBoundingClientRect().width;
      if (w > max) max = w;
    }
    return max;
  }

  function fitGrid(grid) {
    var titles = grid.querySelectorAll('.collections-grid__title');
    if (!titles.length) return;

    // Reset any prior inline size so measurement starts from the CSS base
    // (matters on resize / re-run).
    for (var r = 0; r < titles.length; r++) titles[r].style.fontSize = '';

    var basePx = parseFloat(getComputedStyle(titles[0]).fontSize) || 20;
    var measurer = makeMeasurer(getComputedStyle(titles[0]));

    var minScale = 1;
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      var avail = t.clientWidth;
      if (avail <= 0) continue;
      var need = widestWordPx(measurer, t.textContent);
      if (need > avail) {
        var s = avail / need;
        if (s < minScale) minScale = s;
      }
    }
    measurer.parentNode.removeChild(measurer);

    if (minScale < 1) {
      var px = Math.floor(basePx * minScale * 0.98); // 2% safety margin
      if (px < MIN_PX) px = MIN_PX;
      for (var k = 0; k < titles.length; k++) titles[k].style.fontSize = px + 'px';
    }
  }

  function run() {
    var grids = document.querySelectorAll('.collections-grid');
    for (var i = 0; i < grids.length; i++) {
      var g = grids[i];
      // Skip the predictive-search dropdown — different layout, wraps fine.
      if (g.closest('predictive-search, .predictive-search, .search__results, .header__search')) continue;
      fitGrid(g);
    }
  }

  var timer;
  function debounced() {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run); // re-fit once images/layout settle
  window.addEventListener('resize', debounced);
  document.addEventListener('shopify:section:load', run); // theme editor
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run); // webfont metrics
})();
